import PricingBreakdown from "../components/PricingBreakdown";
import BudgetDashboard from "../components/BudgetDashboard";
import SurplusCalculator from "../components/SurplusCalculator";
import { usePortal } from "../lib/portal";

export default function BudgetPage() {
  const { data } = usePortal();
  return (
    <div className="pt-[110px]">
      <PricingBreakdown pricing={data!.pricing} />
      <BudgetDashboard data={data!} quotes={data!.quotes} />
      <SurplusCalculator
        surplus={data!.surplus}
        seniorsCount={data!.event.seniorsCount}
        juniorsCount={data!.event.juniorsCount}
      />
    </div>
  );
}
